import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '/counter', component: () => import('../components/Counter.vue') },
  {
    path: '/cart-edit',
    component: () => import('../components/cart/CartEdit.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/barcode',
    component: () => import('../components/barcode/BarcodeReader.vue'),
    name: 'barcodereader',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/customers',
    component: () => import('../components/customer/Customers.vue'),
    meta: {
      requiresauth: true,
    },
  },
  {
    path: '/customers/:id',
    component: () => import('../components/customer/CustomerEdit.vue'),
    meta: {
      requiresauth: true,
    },
  },
  {
    path: '/',
    component: () => import('../components/dashboard/Dashboard.vue'),
    name: 'dashboard',
  },
  {
    path: '/orders',
    component: () => import('../components/orders/Orders.vue'),
    name: 'orders',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/orders/processing',
    component: () => import('../components/orders/ProcessingOrdersList.vue'),
    name: 'processingorderslist',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/orders-list',
    component: () => import('../components/orders/OrdersList.vue'),
    name: 'orders-list',
  },
  {
    path: '/orders/:id',
    component: () => import('../components/orders/OrderDetail.vue'),
    name: 'orderdetail',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'products',
        component: () => import('../components/orders/OrderProducts.vue'),
        name: 'orderproducts',
      },
      {
        path: '/invoice',
        component: () => import('../components/orders/OrderDocuments.vue'),
        name: 'orderdocuments',
      },
    ],
  },
  {
    path: '/orders/:id/picking',
    component: () => import('../components/orders/OrderPicking.vue'),
    name: 'orderpicking',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/orders/:id/edit',
    component: () => import('../components/orders/OrderEdit.vue'),
    name: 'orderedit',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/orders/:id/address',
    component: () => import('../components/orders/OrderDetailAddress.vue'),
    name: 'orderdetailaddress',
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/products',
    component: () =>
      import('../components/products/ProductsList/ProductsTable.vue'),
    name: 'products',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/products/new',
    component: () => import('../components/products/ProductNew/ProductNew.vue'),
    name: 'product-new',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/products/movement',
    component: () => import('../components/products/ProductMovement.vue'),
    name: 'product-movement',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/products/:id',
    component: () => import('../components/products/ProductDetail.vue'),
    name: 'product-detail',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/products/:id/edit',
    component: () => import('../components/products/ProductEdit.vue'),
    props: true,
    name: 'product-edit',
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/supply-orders',
    component: () => import('../components/supply-orders/Orders.vue'),
    name: 'supply-orders',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/supply-orders/:id',
    component: () => import('../components/supply-orders/OrderDetail.vue'),
    name: 'supply-order-detail',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/supply-orders/:id/edit',
    component: () => import('../components/supply-orders/SupplyOrderEdit.vue'),
    name: 'supply-order-detail-edit',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/transport-label/:id',
    component: () => import('../components/labels/TransportLabel.vue'),
    name: 'transportlabel',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/transport-label-list',
    component: () => import('../components/labels/TransportLabelList.vue'),
    name: 'transportLabelList',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/stocks',
    component: () => import('../components/stocks/stocks.vue'),
    name: 'stocks',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/stocks/:id',
    component: () => import('../components/stocks/stock.vue'),
    name: 'stock',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/warehouses/:id',
    component: () => import('../components/stocks/stocks.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    component: () => import('../components/auth/Login.vue'),
    name: 'login',
  },
  {
    path: '/users',
    component: () => import('../components/users/Users.vue'),
    name: 'users',
    children: [
      {
        path: 'new',
        component: () => import('../components/users/NewUser.vue'),
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/orders-list',
    component: () => import('../components/orders/OrdersNew.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/inventory-pages',
    component: () => import('../components/prints/InventoryPages.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/inventory',
    component: () => import('../components/inventory/InventoryList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/inventory/:id',
    component: () => import('../components/inventory/InventoryProductList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/suppliers/:id/edit',
    component: () => import('../components/suppliers/SupplierEdit.vue'),
  },
  {
    path: '/suppliers',
    component: () => import('../components/suppliers/Suppliers.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/suppliers/:id',
        component: () => import('../components/suppliers/SupplierOrders.vue'),
        children: [],
      },
    ],
  },
  {
    path: '/suppliers/:id/orders/:orderId/edit',
    component: () => import('../components/suppliers/SupplierDetail.vue'),
  },
  {
    path: '/tasks',
    component: () => import('../components/tasks/TasksPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/categories',
    component: () => import('../components/categories/Categories.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/categories/:id',
    component: () => import('../components/categories/CategoryDetail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/test',
    component: () => import('../components/Test.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '*',
    component: () => import('../components/404.vue'),
  },
];

export default new VueRouter({
  // mode: 'hash',
  routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js